import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { successToast, dangerToast } from '../../../helpers/toast-helper';
import Button, { ButtonGroup } from '../../../components/bootstrap/Button';
import Card, {CardBody, CardHeader} from '../../../components/bootstrap/Card';
import PaginationButtons, {dataPagination, PER_COUNT} from '../../../components/PaginationButtons';
import useDarkMode from '../../../hooks/useDarkMode';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { LIST_STORE_CONTANTS } from '../../../store/constants.store';

import API_ENDPOINTS from '../../../framework/basic-rest/utils/api-endpoints';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../layout/SubHeader/SubHeader';
import {
	sampleHeaders,
	sampleHeadersCompany,
	sampleHeadersCreators,
} from '../crmHelpers/crmConstants';
import Icon from '../../../components/icon/Icon';
import Input from '../../../components/bootstrap/forms/Input';
import Page from '../../../layout/Page/Page';
import { lists } from '../../../store/App/List/list.selector';
import { useGetFilteredCreators } from '../../../framework/basic-rest/crm/creators/filter-creators';
import { useFetchBriefList } from '../../../framework/basic-rest/crm/briefDashboard/get-briefs-list';

const BriefDashboard = () => {


    const {
        data: listBriefs,
        isLoading: listBriefLoading
    } = useFetchBriefList();


    const [perPage, setPerPage] = useState(PER_COUNT['10']);
	const [currentPage, setCurrentPage] = useState(1);


    console.log("data ----- brief ", listBriefs);

    return (
        <PageWrapper>
            <div className='d-flex w-100 justify-content-between pe-5'>
				<span className='h1 mb-0 fw-bold' style={{ paddingLeft: '2rem' }}>
					Brief Dashboard
				</span>
            </div>

            <br />

            <div  className='row mt-4'>
                <Card stretch>
                    <CardBody className='table-responsive overflow-auto'>
                        <table className='table table-modern'>
                            <thead>
                                <tr>
                                    <th className='text-center'>CREATOR NAME</th>
                                    <th className='text-center'>BRIEF MESSAGE</th>
                                    <th className='text-center'>CREATOR REPLY</th>
                                    <th className='text-center'>BRIEF STATUS</th>
                                    <th className='text-center'>CLOSED</th>
                                    <th className='text-center'>CREATED DATE</th>
                                    
                                    <th className='text-center'>EXPIRED</th>
                                    {/* <th className='text-center'>MARK AS FAVORITE</th> */}
                                    {/* <th className='text-center'>ACTIONS</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {!listBriefLoading && listBriefs && 
                                dataPagination(listBriefs, currentPage, perPage).map(
                                    (brief, i) => (
                                            <tr>
                                                <td className='text-center'>
                                                    <span
                                                        className='text-nowrap'
                                                        aria-hidden='true'
                                                        role='button'>
                                                        <Link
                                                            onClick={() => {
                                                            
                                                            }}
                                                            to={`/creator_profile/${brief?.Creator[0]?._id}`}
                                                            style={{
                                                                textDecoration: 'none',
                                                            }}>
                                                            {brief?.Creator[0]?.fullName}
                                                        </Link>
                                                    </span>
                                                    
                                                </td>
                                                <td className='text-center'>
                                                    {brief?.Notes[0]?.notes_body.replace('<p>','').replace('</p>','')}
                                                </td>
                                                <td className='text-center'>
                                                    {brief?.creator_reply}
                                                </td>
                                                <td className='text-center'  style={{color: brief?.isAccepted ? 'green' :'red'}}>
                                                    {brief?.isAccepted ? 'Accepted' : 'Not Accepted'}
                                                </td>
                                                <td className='text-center' style={{color: brief?.isAccepted ? 'red' :'green'}}>
                                                {brief?.isAccepted ? 'Closed' : 'Active'}
                                                </td>
                                                <td className='text-center'>
                                                    {brief?.createdAt}
                                                </td>
                                                <td className='text-center' style={{color:'green'}}>
                                                    Active
                                                </td>
                                                {/* <td className='text-center'>
                                                    <Button
                                                        color='danger'
                                                        icon='heart'
                                                        onClick={() => {
                                                            
                                                        }}/>
                                                </td> */}
                                                {/* <td className='text-center'>
                                                    <Button
                                                        color='light'
                                                        icon='info'
                                                        onClick={() => {
                                                            
                                                        }}>
                                                        Action
                                                    </Button>
                                                </td>    */}
                                            </tr>
                                    )
                                )}
                                
                            </tbody>
                        </table>
                    </CardBody>
                </Card>
            </div>


        </PageWrapper>
    )
}

export default BriefDashboard;